const READING_OFFSET = 120;

export default class TableOfContents {

    static init() {
        const content = document.querySelector('#article-content');
        if (! content) {
            return;
        }
        TableOfContents.initReadingTracking(content);
    }

    static initReadingTracking(content) {
        const headings = Array.from(content.querySelectorAll('h2[id], h3[id]'));
        const links = Array.from(document.querySelectorAll('.table-of-contents-sidebar a[href^="#"]'));
        if (! headings.length || ! links.length) {
            return;
        }
        let awaitingFrame = false;
        const refresh = () => {
            awaitingFrame = false;
            const readHeadings = headings.filter(
                (heading) => heading.getBoundingClientRect().top <= READING_OFFSET
            );
            const readHeading = readHeadings.length ? readHeadings[readHeadings.length - 1] : null;
            links.forEach((link) => link.classList.toggle(
                'active', !! readHeading && link.hash === `#${readHeading.id}`
            ));
        };
        window.addEventListener('scroll', () => {
            if (! awaitingFrame) {
                awaitingFrame = true;
                window.requestAnimationFrame(refresh);
            }
        }, {passive: true});
        refresh();
    }
}
